module.exports = __webpack_public_path__ + "c6555d016f2909dc584dcaa98aa2236f.svg";